import { Navigate } from "react-router-dom";
import { getUser } from "@/lib/user";

/** « Annonces » du menu : envoie le membre vers la consultation des annonces de sa zone. */
export default function AnnoncesRedirection() {
  const user = getUser();
  return <Navigate to={`/categorie/${user?.category || "lago"}/annonces`} replace />;
}
